import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

/**
 * Modal de DETALHE de produto no PDV.
 *
 * Wrapper de UI que orquestra:
 *  - Carrossel de imagens (principal + secundarias) - lazy via `<app-item-imagens-carrossel>`.
 *  - Dados textuais (nome, codigo, preco).
 *  - Selecao de quantidade.
 *  - Botao de confirmacao -> emite `(adicionarAoCarrinho)`.
 *
 * Logica de negocio (variantes, validacoes de estoque, atualizacao do carrinho)
 * permanece no `vendas.component.ts` - este componente apenas notifica.
 */
@Component({
  selector: 'app-vendas-produto-detalhe',
  templateUrl: './vendas-produto-detalhe.component.html',
  styleUrls: ['./vendas-produto-detalhe.component.scss'],
})
export class VendasProdutoDetalheComponent implements OnChanges {
  @Input() produto: any | null = null;
  @Input() idEmpresa: string | undefined;
  @Input() moedaPadrao: string = 'PYG';
  @Input() digitsMoeda: string = '1.2-2';
  @Input() localeMoeda: string = 'pt-BR';

  @Output() adicionarAoCarrinho = new EventEmitter<{ produto: any; quantidade: number }>();
  @Output() fechar = new EventEmitter<void>();

  /** Estado local. */
  visible = false;
  quantidade = 1;
  adicionando = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['produto']) {
      this.quantidade = 1;
      this.adicionando = false;
      this.visible = !!changes['produto'].currentValue;
    }
  }

  podeAdicionar(): boolean {
    return !!this.produto && this.quantidade >= 1 && !this.adicionando;
  }

  confirmar(): void {
    if (!this.podeAdicionar() || !this.produto) return;
    this.adicionando = true;
    this.adicionarAoCarrinho.emit({ produto: this.produto, quantidade: this.quantidade });
  }

  onHide(): void {
    this.visible = false;
    this.fechar.emit();
  }

  cancelar(): void {
    this.onHide();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.visible) this.onHide();
  }

  /**
   * Enter (em qualquer lugar do popup) confirma a adicao ao carrinho.
   * `preventDefault` evita o disparo nativo do botao focado (sem acao dupla);
   * `confirmar()` ja e protegido por `podeAdicionar()`/`adicionando`.
   */
  @HostListener('document:keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent): void {
    if (!this.visible) return;
    event.preventDefault();
    this.confirmar();
  }
}
